exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.log-datos{background-color:#eee;border:1px solid #dfdfdf;padding:8px 10px;font-size:12px;color:#555;font-style:italic\n}\n", "", {"version":3,"sources":["/app/src/components/admin/usuario/LogDatos.vue"],"names":[],"mappings":";AAsFA,WACE,sBACA,yBACA,iBACA,eACA,WACA,iBAAkB;CACnB","file":"LogDatos.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.log-datos {\n  background-color: #eee;\n  border: 1px solid #dfdfdf;\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #555;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7536acf0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/usuario/LogDatos.vue
// module id = wvH7
// module chunks = 0